import { render, staticRenderFns } from "./ReverseTransaction.vue?vue&type=template&id=9f383b84&"
import script from "./ReverseTransaction.vue?vue&type=script&lang=js&"
export * from "./ReverseTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReverseTransaction.vue"
export default component.exports